import { requestJSON } from './request'

// topic for POST/PUT requests
export interface ExistingTopic {
  id: string
}

export interface NewTopic {
  text: string
}

export type TopicField = NewTopic | ExistingTopic

// topic data from SelectTags component for internal usage
export interface SelectedTopic {
  id: string
  text: string
  create: boolean
}

export function selectedTopicToTopicField (tag: SelectedTopic): TopicField {
  if (tag.create) {
    return { text: tag.text }
  } else {
    return { id: tag.id }
  }
}

export enum TopicStatus {
  rejected = 0,
  pending = 1,
  accepted = 2,
  to_be_merged = 3,
}

// topic returned by API
export interface Topic {
  id: number
  name: string
  status: TopicStatus
  is_faceted?: boolean
  is_featured?: boolean
}

export async function getTopics (url: string, controller?: AbortController): Promise<Topic[]> {
  if (controller !== null) {
    return await requestJSON(url, { signal: controller?.signal })
  } else {
    return await requestJSON(url)
  }
}
